import React from "react";
import { ThreeDots } from  'react-loader-spinner';

const CircularProgress = () => <div className='loader'>
  <ThreeDots color="#00BFFF" height={50} width={80} />
</div>;
export default CircularProgress;
